import * as React from "react";
export default function getVehicleSecondaryText(_a) {
    var year = _a.year, trim = _a.trim;
    return (React.createElement("span", { dangerouslySetInnerHTML: {
            __html: [year === null || year === void 0 ? void 0 : year.name, trim === null || trim === void 0 ? void 0 : trim.name]
                .filter(function (val) { return typeof val === "string"; })
                .join(" &middot; "),
        } }));
}
